export const initialData = {
  modelo: '',
  placa: '',
  ano_fabricacao: '',
  ano_modelo: '',
  observacao: '',
}
export default initialData;
  